module.exports = __webpack_public_path__ + "static/media/mobileBg.61777993.png";